<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="nutritionCompliancePerProduct" :options="nutritionCompliancePerProductReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { NUTRITION_COMPLIANCE_PER_PRODUCT_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "NutritionProductCompliance",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      nutritionCompliancePerProduct: null,
    };
  },
  computed: {
    nutritionCompliancePerProductReport() {
      let series = this.nutritionCompliancePerProduct.map((x) => {
        return {
          name: x["cohort"],
          data: x["compliance"].map((c) => [
            c["actionDate"],
            parseInt((parseInt(c["userCount"]) / parseInt(c["totalUserSample"])) * 100),
          ]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Nutrition compliance per product",
        },
        xAxis: {
          categories: this.nutritionCompliancePerProduct[0].compliance.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "% of users",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    nutritionCompliancePerProduct: {
      query: NUTRITION_COMPLIANCE_PER_PRODUCT_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
    },
  },
};
</script>
